import { Observable } from 'rxjs/Observable';
// buggy imports from rxjs for each method that's used in this file. Need to bump to rxjs v6 to fix
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';
import { getProjectSettingsPageUrl } from '@atlassian/jira-servicedesk-common/src/navigation/settings';
import { getPushStateNavigator } from './utils';

export const NAVIGATE = 'navigation.actions.NAVIGATE' as const;

export type Navigate = {
	type: typeof NAVIGATE;
	payload: {
		location: string;
	};
};

export const navigateAction = (location: string): Navigate => ({
	type: NAVIGATE,
	payload: {
		location,
	},
});

/**
 * Navigate to a given location.
 *
 * @param projectKey is the projectKey of the current project
 * @param fragment URL relative to the project settings base URL.
 *
 * Eventually there will be no PushStateNavigator provided by the SD monolith
 * and action-based navigation will be the norm. Start off on the right foot
 * by not assuming that this will be side-effectful; expect an action to be
 * returned every time we navigate.
 */
export const navigate = (projectKey: string, fragment: string): Observable<Navigate> =>
	Observable.fromPromise(getPushStateNavigator())
		.mergeMap((pushStateNavigator) => {
			pushStateNavigator.navigateToFragment(fragment);
			return Observable.empty<never>();
		})
		.catch(() => Observable.of(navigateAction(getProjectSettingsPageUrl(projectKey, fragment))));
